import { render, staticRenderFns } from "./truevo.vue?vue&type=template&id=7f79e80e&"
import script from "./truevo.vue?vue&type=script&lang=js&"
export * from "./truevo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f79e80e')) {
      api.createRecord('7f79e80e', component.options)
    } else {
      api.reload('7f79e80e', component.options)
    }
    module.hot.accept("./truevo.vue?vue&type=template&id=7f79e80e&", function () {
      api.rerender('7f79e80e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/order/truevo/truevo.vue"
export default component.exports